<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>Challenges</h1>
    <div class="head-div">
      <button
        *appHasPermission="'ADD_CHALLENGE'"
        (click)="onAddChallenge()"
        class="cmn-add-btn"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
        Challenge
      </button>
    </div>
  </div>
<div *ngIf="!loading && challengeList.length > 0" class="itemListWrapper">
  <div class="itemWrapper" *ngFor="let challenge of challengeList">
      <div class="story-img-wrapper">
        <img
          [src]="
            challenge.imageURL || '../../../assets/images/placeHolderImage.jpg'
          "
          alt="challenge-img"
          (error)="onImageError($event)"
        />
      </div>
      <h3 class="cmn-list-title">
        {{ challenge?.translations.challengeName.slice(0, 40) }}
      </h3>
      <div class="action-Container">
        <div class="action-wrapper">
          <div
            *appHasPermission="'UPDATE_CHALLENGE'"
            (click)="onEditChallenge(challenge.id)"
            class="iconWrapper"
          >
            <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
          </div>
          <ng-container *appHasPermission="'DELETE_CHALLENGE'">
            <div
              *ngIf="challenge.isCustom === false"
              (click)="deleteChallenege(challenge.id)"
              class="iconWrapper"
            >
              <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
 <div *ngIf="!loading && challengeList.length === 0">
  <app-no-data-component></app-no-data-component>
</div>
<div *ngIf="loading">
  <app-content-loader></app-content-loader>
</div>
</section>
